var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconLikeOff = function SvgIconLikeOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.645 3.478 8 3.837l.355-.36a3.282 3.282 0 0 1 4.675 0 3.37 3.37 0 0 1 0 4.734l-4.967 5.015a.089.089 0 0 1-.126 0L2.97 8.21a3.37 3.37 0 0 1 0-4.733 3.282 3.282 0 0 1 4.675 0Z",
    stroke: "#A4A7AD"
  })));
};
export default SvgIconLikeOff;